/** 
 * Large search form functions. 
 * Conver to TypeScript
 * 
 * Rev 1: 2023-12
 * !TBD: Add google tracker back in.
 */

import { logger, dId, dQS, setHform, showError } from "./utils";
import { setSearchType, setPageId, reservaD} from "./variables";
import { setDict, langDict } from "./dict";

import { checkStoredDates, updateSearchFormVars } from "./store";
import { validate_dropdown_ciudades, validate_search_form } from "./validation";
import { load_dd_offices, check_same_office } from "./offices";
import { attach_datepicker } from "./calendar";
import { google_initialise } from "./google";
import { showYoungDriverWarning } from "./result_detail";
import { filterRes, filter_filters } from "./results_functions";

// Results Logic: 
import { call_results } from "./results_functions";

declare const PRESELECT_VEH: string;
declare const PRESELECT_DESTINO: string;
declare const FURAUTO_TOKEN: string;
declare const PAG_ATRIB: string;
declare const LANG: string;
declare const REVENDOR: string;

  
/** Form prep functions once page is loaded */
document.addEventListener("DOMContentLoaded", bootForm);

function bootForm() {

  logger("Firing up - Round II");

  setDict();

  if (FURAUTO_TOKEN == "") {
    setPageId("N0TSE7", PAG_ATRIB, LANG, REVENDOR);
  } else {
    setPageId(FURAUTO_TOKEN, PAG_ATRIB, LANG, REVENDOR);
  }
   
  draw_hora_select();
  attach_datepicker();
  checkStoredDates();

  // If no data has been sent, then set defaults - otherwise load form/localstorage vars.
  prepopulate_search_fields();
  
  // Load offices then update hidden fields (await):
  load_dd_offices().then(() => {
    validate_dropdown_ciudades("oficina_salida_selector");
  });


  // ------------ Listeners: 

  // FYI: add_ciudades_listeners(); ... after ajax call

  dId("sel_misma_oficina")?.addEventListener("input", () => check_same_office());
  dId("mayor_edad")?.addEventListener("change", () => age_alert(false) );
  dId("mayor_edad_info")?.addEventListener("click", () => age_alert(true) );

  // Vehicle Type Listener: 
  dId("vehicle_tipo_toggle_f")?.addEventListener("click", () => vehicle_tipo_toggle("F", true));
  dId("vehicle_tipo_toggle_t")?.addEventListener("click", () => vehicle_tipo_toggle("T", true));

  // Listeners: 
  dQS("#hora_salida")?.addEventListener("change", (e) => {
    (<HTMLSelectElement>dQS("#hora_vuelta")).value = (<HTMLSelectElement>e.target).value;
  });

  const dateTimes = ["hora_salida", "hora_vuelta", "fecha_salida", "fecha_vuelta"];

  dateTimes.forEach((dt) => {
    dQS("#" + dt)?.addEventListener("change", () => {
      updateSearchFormVars();
    });
  });

  // Submit form:
  dId("call_results")?.addEventListener("click", () => {
    
    logger("Call results","warn");
    let valid = validate_search_form();
    
    if (valid) {
      updateSearchFormVars();
      setHform();
      call_results();
    }
  });


  // Tr to load GA4 reference: 
  google_initialise();


  console.log("%c Estoy perdid@ con el código\n%cTe puedo ayudar:\n >>> https://cdwweb.com 😉  \n", "color: red; text-decoration: line-through", "color:green; font-size:14px; font-weight:bold;");


}



/**
 * Load search fields from snippet passed vars: (set as constants in HTML)
 */
function prepopulate_search_fields() {
  logger("Add Destino and Type from snippet vars", "log");

  vehicle_tipo_toggle(PRESELECT_VEH);

  (<HTMLInputElement>dId("oficina_salida_selector")).value = PRESELECT_DESTINO;
  check_same_office();

}


function vehicle_tipo_toggle(tipo: string, clicked: boolean = false) {

  logger("update search type: " + tipo, "warn");

  let valid = ['T', 'F'];

  if (valid.indexOf(tipo) < 0) {
    logger("error Tipo:" + tipo);
    tipo = "F";
  }

  // Update variable: 
  setSearchType(tipo);



  (<HTMLInputElement>dId("f_tipo_vehiculo")).value = tipo;

  dId("vehicle_tipo_toggle_f")?.classList.remove("selected");
  dId("vehicle_tipo_toggle_t")?.classList.remove("selected");
  dId("vehicle_tipo_toggle_" + tipo.toLowerCase())?.classList.add("selected");

  // Validate Dropdowns in case ciudad is not present on new list: 
  validate_dropdown_ciudades("oficina_salida_selector");
  validate_dropdown_ciudades("oficina_devolucion_selector");

  // Modify filter: 
  filter_filters();

  // Reset filters on change to prevent hidden vehicles:
  if (clicked){
    filterRes(0);
    reservaD[84] = 1;
  }

}


// 2022-05: Age alert in 2 places:  If false, then only show if not checked.
function age_alert(force_show: boolean = false) {

	// for checkbox - only show if not checked:
	if ( (<HTMLInputElement>dId("mayor_edad")).checked) {
    reservaD[14] = "Si";
  } else {
    reservaD[14] = "No";
  }

  showYoungDriverWarning();

  if (force_show || reservaD[14] == "No" ) {
		showError( langDict[65] );
	}

}
	

/**
 * Render time dropdowns:
 */
function draw_hora_select() {

  logger("Add times to dropdowns");

  const sel_o = <HTMLSelectElement>dId("hora_salida");
  const sel_i = <HTMLSelectElement>dId("hora_vuelta");

  sel_o.add(new Option("sel.", "-"));
  sel_i.add(new Option("sel.", "-"));

  for (let i = 7; i <= 23; i++) {

    let t = ("0" + i).slice(-2) + ":00";
    sel_o.add(new Option(t, t));
    sel_i.add(new Option(t, t));

    const opt = document.createElement("option");
    t = ("0" + i).slice(-2) + ":30";
    sel_o.add(new Option(t, t));
    sel_i.add(new Option(t, t));

  }

  sel_o.selectedIndex = 0;
  sel_i.selectedIndex = 0;

}


// GLOBAL function - For loading saved search into reservaD array:
function updateReservaData(provname:string, provid:number, 
                          provdname:string, provdid:number,
                          city:string, cityd:string,
                          pais: string, paisd: string) {

  reservaD[6] = provname;
  reservaD[15] = provid;
  reservaD[11] = provdname;
  reservaD[16] = provdid;
  reservaD[12] = city;
  reservaD[13] = cityd; 

  reservaD[36] = pais; 
  reservaD[37] = paisd; 

  setHform();

  logger("Call results","warn");
  let valid = validate_search_form();
  
  if (valid) {
    updateSearchFormVars();
    setHform();
    call_results();
  }
  

}

// @ts-ignore
window["updateReservaData"]= updateReservaData;
window["vehicle_tipo_toggle"]= vehicle_tipo_toggle;
